/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {
  useState,
  useEffect
} from "react";

const useCheckMobileView = () => {
  const [isMobileView, setIsMobileView] = useState();

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    setIsMobileView(isMobile);
  }, []);
  return isMobileView;
};

export default useCheckMobileView;
